import React from 'react';
import { Trans } from 'react-i18next';

export const LimitTxTypeMenus = [
  {
    label: 'Token txs',
    value: 'token' as const,
  },
  {
    label: 'NFT txs',
    value: 'nft' as const,
  },
  {
    label: 'Token & NFT txs',
    value: undefined,
  },
];

export const LimitTxAmountMenus = [
  {
    label: <Trans i18nKey="HistoryAnalysisView.analysisTx" values={{ amount: 'all' }} />,
    value: undefined,
  },
  {
    label: <Trans i18nKey="HistoryAnalysisView.analysisTx" values={{ amount: '>$10' }} />,
    value: 10 as const,
  },
  {
    label: <Trans i18nKey="HistoryAnalysisView.analysisTx" values={{ amount: '>$100' }} />,
    value: 100 as const,
  },
  {
    label: <Trans i18nKey="HistoryAnalysisView.analysisTx" values={{ amount: '>$1000' }} />,
    value: 1000 as const,
  },
  {
    label: <Trans i18nKey="HistoryAnalysisView.analysisTx" values={{ amount: '>$10000' }} />,
    value: 10000 as const,
  },
];
